import { render, staticRenderFns } from "./protocolDetail.vue?vue&type=template&id=51219e70"
import script from "./protocolDetail.vue?vue&type=script&lang=js"
export * from "./protocolDetail.vue?vue&type=script&lang=js"
import style0 from "./protocolDetail.vue?vue&type=style&index=0&id=51219e70&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports